<template>
    <div class="default-group">
        <div class="card-curvey group-card mt-0">
            <v-layout row nowrap>
                <v-flex xs-6
                    v-for="(block,index) in defaultGroup"
                    :key="`default-group${index}`"
                >
                    <v-btn
                        large round block
                        :color="selectedBlock.id === block.id ? 'primary': '#F4F5F9'"
                        @click="setSelectedBlock(block)"
                    >
                        {{block.name}}
                    </v-btn>
                </v-flex>
            </v-layout>
        </div>
        <div class="card-curvey group-card">
            <draggable @change="draggedToGroup" class="layout row wrap" v-model="firstGroupList" group="people" @start="drag=true" @end="drag=false" handle=".blockHandeler">
                <v-flex xs4
                    v-for="(block,index) in firstGroupList"
                    :key="`first-group${index}`"
                    class="blockHandeler"
                >
                    <v-btn
                        large round block
                        :color="selectedBlock.id === block.id ? 'primary': '#F4F5F9'"
                        @click="setSelectedBlock(block)"
                    >
                        {{block.name}}
                    </v-btn>
                </v-flex>
                <v-flex xs4>
                    <v-btn
                            large round  block
                            class="text-gray"
                            @click="addNewBlock(0)"
                            color="white"
                    >
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-flex>
            </draggable>
            <div class="">

            </div>
        </div>
    </div>
</template>

<script>
    import common from "../../../utils/common";
    import * as _ from "lodash";
    import draggable from 'vuedraggable'

    export default {
        name: "default-group",
        components: {
            draggable
        },
        props: {
            defaultGroup: {
                type: Array,
                default: ()=> {
                    return []
                }
            },
            firstGroup: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return{
                firstGroupList: []
            }
        },
        mounted() {
            this.firstGroupList = this.firstGroup
        },
        methods: {
            setSelectedBlock(block) {
                this.$store.dispatch('setSelectedBlock',block)
            },
            addNewBlock(group_id) {
                this.$store.dispatch('setSavingStatus', true)
                this.$store.dispatch('setLoader',true)
                this.$http.post('/blocks',{
                    bot_id: this.botId,
                    group_id: group_id,
                    iGroup: -1,
                    name: `Untitled Block ${this.firstGroup.length+1}`,
                    payload: []
                })
                    .then(response=>{
                        this.firstGroup.push(response.data)
                        this.$store.dispatch('setSelectedBlock',response.data)
                        this.$store.dispatch('setNewBlock',response.data)
                        this.$store.dispatch('setSavingStatus', false)
                        this.$store.dispatch('setLoader',false)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            draggedToGroup(newItem) {
                if(newItem.added || newItem.moved) {
                    this.updateBlockPosition(newItem.added || newItem.moved)
                }
            },
            async updateBlockPosition(newItem) {
                await this.$store.dispatch('setSavingStatus', true)
                await this.$store.dispatch('setLoader',true)
                let payload = await this.getBlockPayLoad(newItem.element.id)
                this.$http.put(`/blocks/${newItem.element.id}`,  {
                    group_id: 0,
                    name: newItem.element.name,
                    payload: payload.data.payload,
                    order: newItem.newIndex
                })
                    .then(response=>{
                        this.$store.dispatch('setSavingStatus', false)
                        this.$store.dispatch('setLoader',false)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            async getBlockPayLoad(blockId) {
                let response = await this.$http_bot.get(`/blocks/${blockId}`)
                return response
            },
            copyBlock() {
                this.$store.dispatch('setSavingStatus', true)
                this.$store.dispatch('setLoader',true)
                this.$http.post('/blocks', {
                    bot_id: this.botId,
                    group_id: this.copiedBlock.group_id,
                    iGroup: -1,
                    name: `${this.copiedBlock.name} Copy`,
                    payload: this.copiedBlock.payload
                })
                    .then(response=>{
                        this.firstGroup.push(response.data)
                        this.$store.dispatch('setSelectedBlock',response.data)
                        this.$store.dispatch('setNewBlock',response.data)
                        this.$store.dispatch('setSavingStatus', false)
                        this.$store.dispatch('setLoader',false)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
        },
        computed: {
            selectedBlock () {
                return this.$store.state.blocksBuild.selectedBlock
            },
            botId() {
                return this.$store.state.bot.botId
            },
            copiedBlock() {
                return this.$store.state.blocksBuild.copiedBlock
            },
            updatedBlockName() {
                return this.$store.state.blocksBuild.updatedBlockName.name
            }
        },
        watch: {
            copiedBlock(state) {
                if (state.id && state.group_id === 0) {
                    this.copyBlock()
                }
            },
            firstGroup() {
                this.firstGroupList = this.firstGroup
            },
            updatedBlockName(state) {
                const block = this.$store.state.blocksBuild.updatedBlockName
                if (state) {
                    let index = _.findIndex(this.firstGroup,o=>{
                        return o.id === block.id
                    })
                    if (index !== -1) {
                        this.firstGroup[index].name = block.name
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>